import {getIAMSmartAuthorizeUrl} from "../../services/api/socialIdentityApi";
import {useEffect, useState} from "react";
import {Redirect} from "react-router-dom";

const IAMSmartRedirect = () => {
	const [completed, setCompleted] = useState(false);

	useEffect(() => {
		(async () => {
			try {
				const response = await getIAMSmartAuthorizeUrl();

				if (!response?.data?.data) {
					setCompleted(true);
					return;
				}

				window.location.href = response.data.data;
			}
			catch(_) {
				setCompleted(true);
			}
		})();
	}, []);

	if(completed) {
		return (<Redirect to={'/'} />);
	}

	return (<></>);
};

export default IAMSmartRedirect;
